import React from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Navigate } from 'react-router-dom';
import LoadingLogo from '../components/LoadingLogo';

const ProtectedRoute = ({ children }) => {
  const { user, authStatus } = useAuthenticator((context) => [
    context.user,
    context.authStatus,
  ]);

  // En attente du chargement de l'authentification
  if (authStatus === 'configuring') {
    return <LoadingLogo />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
